module.exports = __webpack_public_path__ + "img/send_video_reply.28f72d5f.svg";